import { useEffect, useState } from "react";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const handleChoice = (type) => {
    localStorage.setItem("cookieConsent", type); // "all" | "necessary" | "none"
    setVisible(false);
    window.location.reload(); // wymuś przeładowanie w celu aktywacji/dezaktywacji np. GA
  };

  if (!visible) return null;

  return (
    <div className="fixed top-0 left-0 right-0 h-full bg-black/95 text-white p-4 z-50 flex flex-col md:flex-row justify-center items-center gap-4 shadow-lg">
      <p className="text-sm max-w-md">
        Ta strona korzysta z plików cookies do działania oraz analizy ruchu.
        Wybierz, na co wyrażasz zgodę. Zobacz{" "}
        <a href="/polityka-prywatnosci" className="underline">
          politykę prywatności
        </a>
        .
      </p>
      <div className="flex gap-2 flex-wrap">
        <button
          onClick={() => handleChoice("all")}
          className="bg-red-600 px-4 py-2 rounded-md text-sm font-bold"
        >
          Akceptuję wszystkie
        </button>
        <button
          onClick={() => handleChoice("necessary")}
          className="bg-gray-700 px-4 py-2 rounded-md text-sm font-bold"
        >
          Tylko niezbędne
        </button>
        <button
          onClick={() => handleChoice("none")}
          className="bg-gray-800 px-4 py-2 rounded-md text-sm font-bold"
        >
          Odrzucam
        </button>
      </div>
    </div>
  );
}
